import { Divider, Typography, Box, makeStyles } from "@material-ui/core";
import { formatDate } from "@itarget/shared";
import AccessTimeIcon from "@material-ui/icons/AccessTime";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.25),
    marginBottom: theme.spacing(0.5),
    padding: theme.spacing(0.25),
  },
  dateText: {
    fontSize: "0.875rem",
  },
  timeIcon: {
    fontSize: "1rem",
  },
}));

const StepBlock = ({ date, steps }) => {
  const classes = useStyles();
  const stepKeys = Object.keys(steps).filter((step) => step !== "");
  const firstStep = steps[stepKeys[0]];
  if (!firstStep?.[0]?.hora_inicio) return null;

  return (
    <Box className={classes.root}>
      <AccessTimeIcon className={classes.timeIcon} />
      <Typography className={classes.dateText}>
        {formatDate.getDay(date)} de {formatDate.monthInFull(date)} das{" "}
        {formatDate.hour(firstStep[0].hora_inicio)} -{" "}
        {formatDate.hour(firstStep[0].hora_fim)}
      </Typography>
    </Box>
  );
};

export default StepBlock;
